<script>
import StockAdjustmentTypeForm from "./Form.vue";

export default {
    name: "StockAdjustmentTypeList",

    data() {

        return {};
    },

    components: {

        StockAdjustmentTypeForm
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `master-data.accounts.index` }">Accounts master data</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Stock Adjustment Types</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex w-full">
            <h5 class="flex-1 text-sm">Stock Adjustment  Types</h5>
          </div>
        </template>
        <template v-slot:card-body>
            <StockAdjustmentTypeForm/>
            <div class="w-full overflow-auto">
              <table class="table table-hover">
                <thead class="bg-blue-500 text-xs text-white">
                  <tr class="w-full flex">
                    <th class="p-tiny w-1/6">Code</th>
                    <th class="p-tiny w-1/6">Type</th>
                    <th class="p-tiny w-1/6">Increments</th>
                    <th class="p-tiny w-1/6">Decrements</th>
                    <th class="p-tiny w-1/6">Active</th>
                    <th class="p-tiny w-1/6">Action</th>
                  </tr>
                </thead>
                <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:65vh;">
                  <tr class="flex w-full">
                    <td class="p-tiny w-1/6"></td>
                    <td class="p-tiny w-1/6"></td>
                    <td class="p-tiny w-1/6"></td>
                    <td class="p-tiny w-1/6"></td>
                    <td class="p-tiny w-1/6"></td>
                    <td class="p-tiny w-1/6"></td>
                  </tr>
                </tbody>
              </table>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
